import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { FiChevronRight, FiStar } from 'react-icons/fi'
import { Link, NavLink } from 'react-router-dom'
import Flex from 'typescript-styled-flex'
import { connect, useSelector } from 'react-redux'
import { License } from '../../../../../components/Template/Premium'
import Header from '../../../../../components/Template/Premium/Header/Header'
import { theme } from '../../../../../theme'
import getDays from '../../../../../utils/License/getDays'
import getFinalValidLicenses from '../../../../../utils/License/getFinalValidLicenses'
import Typography from '../components/Typography'
import Sidebar from '../Sidebar'
import { getUserSettings } from '../../../../../reducers/userObject/selectors/settings'
import { IPremiumLicenses, mapLicenseToIcon, mapLicenseToName } from '../../Menu/Premium/PremiumLicenses'
import { ILicense } from '../../../../../models/License'
import { getAccessToken } from '../../../../../reducers/userAccount/selectors/credentials'
import { getPanelUrlForEnv } from '../../../../../utils/ApiUrl'
import { isEmpty } from 'lodash'
import Error from '../../../../../assets/icons/error2.svg'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import Button from '../../../../../components/Template/Button'

import ButtonLabel from '../components/ButtonLabel'

function PremiumMenu({
  licenses,
  validLicenses,
  t,
  formatDate,
}: IPremiumMenu & WithTranslation) {
  const [open, setOpen] = React.useState<boolean>()
  const key = useSelector(getAccessToken)

  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })


  function toggleOpen() {
    setOpen(!open)
  }

  const finalLicenses = getFinalValidLicenses(validLicenses)
  const days = getDays(finalLicenses.active)

  const subError = Object.values(finalLicenses).some(l => {
    return l.some(license => {
      if(isEmpty(license.sub)) return false
      return license.sub.status_extended === 'PAYMENT_ERROR'
    })
  })

  function goToPremium() {
    //var EnvUrl = getApiUrlForEnv()
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
  }

  const isSub = Object.values(finalLicenses).some(l => {
    return l.some(license => {
      if(isEmpty(license.sub)) return false
      return license.sub.status_extended === 'ACTIVE' || license.sub.status_extended === 'WAITING'
    })
  })

  return (
    <React.Fragment>
      {days >= 0 && (
        <React.Fragment>
          <ListItem
            button={true}
            style={{
              backgroundColor: theme.colors.palette.emerald,
              minHeight: '60px',
            }}
            onClick={toggleOpen}
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              {subError ? (
                <img style={{
                }} alt={'icon'} src={Error} />

              ):(<FiStar style={{ color: 'white' }} size={20} />)}
            </ListItemIcon>
            <ListItemText
              primary={
                isSub? <Typography style={{ color: 'white' }}>{`${t(
                  'menu_upgrade',
                )}: ${subError? t('BED_26058_payment_issue'):t('BKO_773_DefaultTaxRateActive').toLowerCase()}`}</Typography>:   <Typography style={{ color: 'white' }}>{`${t(
                  'menu_upgrade',
                )}: ${days} ${t(
                  days === 1 ? 'days_count_day' : 'days',
                )}`}</Typography>
              }
            />
            <FiChevronRight style={{ color: 'white' }} />
          </ListItem>

          <Sidebar
            closeDrawer={toggleOpen}
            open={open}
            headerIcon={
              <FiStar
                color={theme.colors.palette.greyishBrown}
                size={20}
                style={{ minHeight: 20, minWidth: 20 }}
              />
            }
            headerLabel={t('menu_upgrade')}
            elevation={0}
            scrollable={true}
          >
            {scopes.premium && !isSub && (
              <Button
                as={Link}
                style={{ height: '38px', margin: '15px 15px' }}
                primary={true}
                onClick={goToPremium}
              >
                <ButtonLabel>{t('prolong_access')}</ButtonLabel>
              </Button>
            )}

            <Header
              active={true}
              label={t('BBO_934_active_services')}
              validLicenses={finalLicenses.active}
              style={{ width: '310px' }}
            />

            {finalLicenses.active.map(license => (
              <License
                icon={mapLicenseToIcon(license)}
                label={t(mapLicenseToName(license, t))}
                endTime={license.license}
                rawEnd={license.rawDate}
                sub={license.sub}
                startTime={license.startLicense}
                roomLimit={license.roomLimit}
                formatDate={formatDate}
              />
            ))}

            {finalLicenses.awaits.length !== 0 && (
              <>
                <Header
                  style={{
                    borderTop: `1px solid ${theme.colors.palette.emerald}`,
                    width: '310px',
                  }}
                  active={false}
                  label={t('BED_5438_pending_services')}
                  validLicenses={finalLicenses.awaits}
                />

                {finalLicenses.awaits.map(license => (
                  <License
                    icon={mapLicenseToIcon(
                      license,
                      1,
                      theme.colors.palette.slateGrey,
                    )}
                    label={t(mapLicenseToName(license, t))}
                    endTime={license.license}
                    sub={license.sub}
                    awaits={true}
                    rawEnd={license.rawDate}
                    startTime={license.startLicense}
                    roomLimit={license.roomLimit}
                    formatDate={formatDate}
                  />
                ))}
              </>
            )}
          </Sidebar>
        </React.Fragment>
      )}
      {days < 0 && (
        <NavLink to={'#'} onClick={goToPremium}>
          <ListItem
            style={{
              backgroundColor: theme.colors.palette.emerald,
              minHeight: '60px',
            }}
          >
            <Flex alignCenter={true} justifyCenter={true} full={true}>
              <ListItemText
                primary={
                  <Typography
                    style={{
                      color: 'white',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {t('info_slider_bay_premium')}
                  </Typography>
                }
              />
            </Flex>
          </ListItem>
        </NavLink>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state): IPremiumLicenses => {
  const format = getUserSettings(state).dateFormat

  return {
    formatDate: format ? format.date : null,
  }
}

export default withTranslation()(connect(mapStateToProps)(PremiumMenu) as any) as any

export interface IPremiumMenu {
  licenses?: ILicense[]
  validLicenses?: ILicense[]
  toggleMenu?: () => void
  formatDate?: string
}
